import CodeEditor from "components/CodeEditor";
import DrawerBody from "ds/components/Drawer/Body";
import DrawerHeader from "ds/components/Drawer/Header";
import DrawerCloseIcon from "ds/components/DrawerNew/CloseIcon";
import DrawerHeaderTitle from "ds/components/DrawerNew/HeaderTitle";
import DrawerSimple from "ds/components/DrawerNew/Simple";
import { createDrawer, createDrawerTrigger } from "ds/components/DrawerNew/utils";

type PluginTemplateDetailsDrawerProps = {
  templateName: string;
  manifest: string;
};

const PluginTemplateDetailsDrawer = createDrawer(
  ({ templateName, manifest }: PluginTemplateDetailsDrawerProps) => {
    return (
      <DrawerSimple isDismissable>
        <DrawerHeader justify="between">
          <DrawerHeaderTitle title={templateName} />
          <DrawerCloseIcon />
        </DrawerHeader>
        <DrawerBody fullHeight>
          <CodeEditor body={manifest} language="yaml" rounded readOnly />
        </DrawerBody>
      </DrawerSimple>
    );
  }
);

export const showPluginTemplateDetailsDrawer = createDrawerTrigger(PluginTemplateDetailsDrawer);
